import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EventService} from "../../../../core/services/event.service";
import {AppService} from "../../../../core/services/app.service";

@Injectable({
  providedIn: 'root'
})
export class ReplyCommentService extends EventService {

  private replyCommentAPI = AppService.getApiUrl() + '/api/replyComments';

  constructor(private http: HttpClient) {
    super();
  }

  public updateComment(params) {
    return this.http.put(this.replyCommentAPI + `/${params.id}`, params);
  }

  public removeComment(id) {
    return this.http.delete(this.replyCommentAPI + `/${id}`);
  }

  public replyComment(params) {
    return this.http.post(this.replyCommentAPI, params);
  }
}
